import { I18NConfigSchema } from "slotworks/config/i18n-config-schema";
import { Services } from "slotworks/services/services";

export class Translations {

    /**
     * DEPRECATED. Use Services.currency instead
     */
    public get debug() {
        return Services.translations.debug;
    }

    /**
     * DEPRECATED. Use Services.translations instead
     */
    public set debug(value) {
        Services.translations.debug = value;
    }

    /**
     * DEPRECATED. Use Services.translations instead
     */
    public get formats() {
        return Services.translations.formats;
    }

    /**
     * DEPRECATED. Use Services.translations instead
     */
    public set formats(value) {
        Services.translations.formats = value;
    }

    /**
     * DEPRECATED. Use Services.translations instead
     */
    public get breakWords() {
        return Services.translations.breakWords;
    }

    /**
     * DEPRECATED. Use Services.translations instead
     */
    public set breakWords(value) {
        Services.translations.breakWords = value;
    }

    /**
     * DEPRECATED. Use Services.translations instead
     */
    public get code() {
        return Services.translations.code;
    }

    /**
     * DEPRECATED. Use Services.translations instead
     */
    public set code(value) {
        Services.translations.code = value;
    }

    /**
     * DEPRECATED. Use Services.translations instead
     */
    public setLanguage(code: string) {
        Services.translations.setLanguage(code);
    }

    /**
     * DEPRECATED. Use Services.translations instead
     */
    public setConfig(config: I18NConfigSchema) {
        Services.translations.setConfig(config);
    }

    /**
     * DEPRECATED. Use Services.translations instead
     */
    public load(json: any) {
        Services.translations.load(json);
    }

    /**
     * DEPRECATED. Use Services.translations instead
     */
    public set(id: string, translation: string) {
        Services.translations.set(id, translation);
    }

    /**
     * DEPRECATED. Use Services.translations instead
     */
    public get(id: string, parameters?: { [value: string]: string | number }): string {
        return Services.translations.get(id, parameters);
    }

    /**
     * DEPRECATED. Use Services.translations instead
     */
    public updateDOMTexts() {
        Services.translations.updateDOMTexts();
    }

    /**
     * DEPRECATED. Use Services.translations instead
     */
    public convertTags(text: string): string {
        return Services.translations.convertTags(text);
    }
}

export default new Translations();
